const routes = {
  mediaPlanning: 'media-planning',
};

export default routes;
